<div class="row added-background">
  <div class="row first-element">
    <div class="col-2">
      <label i18n>ID:</label>
    </div>
    <div class="col-6">
      <p>{{ item.id }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label i18n>Version:</label>
    </div>
    <div class="col-6">
      <p>{{ item.version }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label i18n>Source:</label>
    </div>
    <div class="col-6">
      <p>{{ item.source }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label i18n>Note:</label>
    </div>
    <div class="col-6">
      <p>{{ item.note }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label i18n>Created by:</label>
    </div>
    <div class="col-6">
      <p>{{ item.created_by }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label i18n>Created on:</label>
    </div>
    <div class="col-6">
      <p>{{ utility.convertUnixTime_global(item.created_ts) }}</p>
    </div>
  </div>
</div>
